<template>
  <!-- 付款单管理 -->
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            trackCode='paymentList-1'
            @search="handleSearch"
            @reset="handleReset"
          >
            <template slot="batch-search-btn">
              <el-button
                type="primary"
                :size="formSize"
                :loading="loading"
                @click="handleBatchSearch()"
              >
                批量查询
              </el-button>
            </template>
          </jr-search2>
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList">
            <template #payWays>
              <page-select-cascader
                :selectOptions="selectWayOptions"
                :selectList="queryForm.selectList"
                :cascaderStyle="{minWidth: '250px'}"
                @change="cascaderChange"
                :cascaderProps="cascaderProps"
                :hasAll="false"
              />
            </template>
          </page-select-groups>
          <div class="fan-search-col fan-search-right">
            <!-- 表格数据配置 -->
            <jr-columns-config
              :columnsKey="columnsKey"
              :tableColumn="tableColumn"
              :selectTableColumn="selectTableColumn"
              :recommendedColumn="recommendedColumn"
              @confirm="handleConfirm"
            />
            <div v-if="$has('FWS-SFKGL-FKD-FZZY')">
              <el-button
                type="primary"
                :size="formSize"
                :disabled="!multipleSelection || multipleSelection.length === 0"
                @click="handleCopyDigest()"
                v-track
                trackCode="paymentList-3"
              >
                复制摘要
              </el-button>
            </div>
            <div style="margin-left: 10px" v-if="$has('FWS-SFKGL-FKD-HBFK')">
              <el-button
                type="primary"
                icon="el-icon-success"
                :size="formSize"
                :disabled="!multipleSelection || multipleSelection.length === 0"
                @click="handleMergePayment()"
                v-track
                trackCode="paymentList-4"
              >
                合并付款
              </el-button>
            </div>
            <div style="margin-left: 10px" v-if="$has('FWS-SFKGL-FKD-FK')">
              <el-button
                type="primary"
                icon="el-icon-success"
                :size="formSize"
                :disabled="!multipleSelection || multipleSelection.length === 0"
                @click="handleBatchPayment()"
                v-track
                trackCode="paymentList-5"
              >
                {{ batchPaymentStr }}
              </el-button>
            </div>
            <!-- 导出报表按钮 -->
            <div style="margin-left: 10px" v-if="$has('FWS-SFKGL-FKD-DC')">
              <page-export-button
                title="付款单报表导出"
                button-text="导出"
                :exportServe="exportServe"
                :total="total"
                :exportParams="exportParams"
                @close="onCloseExport"
                :hasDate="false"
                :customMain="true"
                trackCode="paymentList-6"
              >
                <template v-slot:main>
                  <data-show label="导出类型:">
                    <el-radio v-model="exportType" :label="1">按订单类型</el-radio>
                    <el-radio v-model="exportType" :label="2">按账单类型</el-radio>
                  </data-show>
                </template>
              </page-export-button>
            </div>
          </div>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="selectTableColumn"
          @selection-change="handleSelectionChange"
          ref="paymentListRef"
        >
          <template v-slot:realRecAmountLabel="{ column }">
            <span>
              {{ column.label }}
              <el-tooltip class="item" effect="dark" content="「- 」表示存在合并付款，需点击【付款单号】进入详情查看" placement="top-start">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
          </template>
          <template v-slot:orderNumber="{row}">
            <jr-tooltip
              :content="row.orderNumber"
              type="popover"
              :isFilter="true"
            />
          </template>
          <template v-slot:bankCardNumber="{row, column}">
            <template v-if="row.payMode === 'ALIPAY' && row.payWay === 32">
              <jr-preview-image
                v-if="row.qrCodeUrl"
                :row-id="row.id"
                :image-list="$stringToArray(row.qrCodeUrl)"
              />
              <span v-else>-</span>
            </template>
            <span v-else>
              <page-encrypt-icon
                :value.sync="row[`${column.prop}-new`]"
                :encryptValue="row.bankCardNumber"
              />
            </span>
          </template>
          <template v-slot:certificate="{row}">
            <span v-if="!row.certificate">-</span>
            <jr-preview-image
              v-else
              :row-id="row.id"
              :image-list="$stringToArray(row.certificate)"
            />
          </template>
          <template v-slot:options="{row}">
            <btns-operate
              :current="row"
              :type="queryForm.type"
              @success="handleOperateStateResults"
            />
          </template>
        </jr-table>
      </template>
      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
    <!-- 详情 -->
    <detail
      v-if="isDetailShow"
      :visible.sync="isDetailShow"
      :payment-no.sync="paymentNo"
      :source-type.sync="sourceType"
      @operate-success="getList"
    />
    <!-- 合并付款/再次付款 相同客户、账户 -->
    <payment-operate
      :visible.sync="isPaymentOperateShow"
      :payment-no="paymentNo"
      :payment-obj="paymentObj"
      :is-batch="isBatchPay"
      :title="paymentTitle"
      :type="paymentType"
      @success="handleOperateStateResults()"
    />
    <!-- 批量付款/退款 不完全相同客户、账户-->
    <batch-pay-dialog
      :visible.sync="isBatchPaymentShow"
      :payment-no="paymentNo"
      :payment-obj="paymentObj"
      :title="paymentTitle"
      @success="handleOperateStateResults()"
    />
    <!-- 批量搜索 -->
    <batch-search
      :visible.sync="isBatchSearchShow"
      :type-list="batchSearchTypeList"
      :searchType="queryForm.searchType"
      :loading="loading"
      @confirm="handleBatchSearchConfirm"
      trackCode="paymentList-2"
    />

    <payment-tip-dialog :visible.sync="isPaymentTipShow" :dataInfo="checkResultInfo" />
  </div>
</template>

<script>
import { getPaymentPaymentList, payCommitCheck } from '@/api/receivables';
import detail from './components/detail';
import * as _ from 'lodash';
import batchPayDialog from './components/batch-pay-dialog';
import { regFenToYuan } from '@/utils/number';
import { setStatusColor } from '@/filters/index';
import btnsOperate from './components/btns-operate';
import paymentOperate from './components/payment-operate'; // 再次付款
import { getMonthDate } from '@/utils/date';
import paymentTipDialog from './components/payment-tip-dialog'; // 付款提示弹窗

const queryFormDefault = {
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  searchContent: '', // 搜索值
  searchType: '1',
  status: '', // 付款单状态
  type: '', // 类型
  transType: 2, // 订单交易类型1=自营2=服务商
  timeType: '1',
  selectList: [],
  serviceType: '', // 服务商类型
  payWays: [],
  payMode: '',
};

const dictTypes = {
  serviceType: '/common/general/serviceType',
  FinPaymentTypeEnum: '/finance/finance-payment/FinPaymentTypeEnum',
  FinPayModeEnum: '/finance/finance-payment/PaymentModleEnum',
  FinPaymentStatusEnum: '/finance/finance-payment/FinPaymentStatusEnum',
};

export default {
  name: 'paymentList',
  components: { detail, batchPayDialog, btnsOperate, paymentOperate, paymentTipDialog },
  data() {
    const list = [
      { value: '1', label: '业务订单编号' },
      { value: '2', label: '付款申请单编号' },
      // {
      //   value: '3',
      //   label: '应付单编号',
      // },
      { value: '4', label: '付款单编号' },
      { value: '5', label: '客户编号' },
    ];
    return {
      loading: false,
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '创建时间', value: '1' },
            { label: '付款时间', value: '2' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'searchContent',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: [
            ...list,
            {
              value: '6',
              label: '客户名称',
            }, {
              value: '7',
              label: '付款审核人',
            }, {
              value: '8',
              label: '服务商名称',
            },
          ],
        },
      ],
      paymentNo: '', // 付款单编号
      sourceType: 1, // 区别新旧数据
      isDetailShow: false, // 详情弹窗
      /** ------批量操作---- */
      multipleSelection: [], // 选中的数据
      /** ------批量搜索操作---- */
      batchSearchTypeList: [...list], // 批量搜索搜索条件集合
      isBatchSearchShow: false, // 批量搜索
      isBatchPaymentShow: false, // 批量付款（不完全相同）
      tableColumn: [
        {
          type: 'selection',
          width: '40',
          align: 'center',
          isShow: () => false,
          show: () => this.$has('FWS-SFKGL-FKD-FK'),
          // selectable: (row) => this.setDisabled(row),
        },
        {
          prop: 'paymentNo',
          label: '付款单单号',
          minWidth: '1',
          trackCode: 'paymentList-7',
          click: (row) => this.handleDetail(row),
          show: () => this.$has('FWS-SFKGL-FKD-XQ'),
          disabled: true,
        },
        { prop: 'payApplyNumber', label: '付款申请单编号', minWidth: '1' },
        { prop: 'orderNumber', slotName: 'orderNumber', label: '业务订单编号', minWidth: '1' },
        { prop: 'typeDesc', label: '付款单类型', minWidth: '1' },
        { prop: 'businessName', label: '客户名称', minWidth: '1' },
        { prop: 'businessNo', label: '客户编号', minWidth: '1' },
        { prop: 'payeeBusinessName', label: '服务商名称', minWidth: '1' },
        { prop: 'serviceTypeDesc', label: '服务商类型', minWidth: '1' },
        { prop: 'payModeDesc', label: '付款方式', minWidth: '1' },
        { prop: 'payWayDesc', label: '付款渠道', minWidth: '1' },
        { prop: 'payAmount', label: '付款金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'realRecAmount', label: '采购商实收金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', headerSlotName: 'realRecAmountLabel' },
        { prop: 'certificate', slotName: 'certificate', label: '付款凭证', minWidth: '1' },
        { prop: 'bankAccountName', label: '收款户名', minWidth: '1' },
        { prop: 'bankCardNumber', label: '收款账户', minWidth: '1', slotName: 'bankCardNumber' },
        { prop: 'crtime', label: '创建时间', minWidth: '1', filterName: 'formatTime', disabled: true },
        { prop: 'payApplyUser', label: '付款申请人', minWidth: '1' },
        { prop: 'status', label: '状态', status: 'status', disabled: true, statusDesc: 'statusDesc', statusColor: (val) => setStatusColor(val, 'paymentStatus') },
        { prop: 'operatorName', label: '付款人', minWidth: '1' },
        { prop: 'operate', slotName: 'options', label: '操作', width: '110', disabled: true },
      ],
      paymentType: '', // 付款类型-综合/线下/线上
      isBatchPay: false, // 是否批量付款
      paymentObj: {}, // 付款单对象
      isPaymentOperateShow: false, // 发起付款再次付款
      paymentTitle: '', // 标题
      exportType: 1,
      columnsKey: 'fwsPaymentList',
      selectTableColumn: [],
      recommendedColumn: [
        { prop: 'payTime', label: '付款时间', minWidth: '1', filterName: 'formatTime' },
        { prop: 'payReason', label: '付款原因', minWidth: '1', showOverflowTooltip: true },
      ],
      cascaderProps: {
        multiple: true,
        checkStrictly: true,
        value: 'value',
        label: 'codeName',
        children: 'childs',
      },
      selectList: [
        {
          title: '服务商类型',
          prop: 'serviceType',
          dictionaryPath: dictTypes.serviceType,
        },
        {
          title: '付款单类型',
          prop: 'type',
          dictionaryPath: dictTypes.FinPaymentTypeEnum,
        },
        {
          title: '付款方式',
          slotName: 'payWays',
          dictionaryPath: dictTypes.FinPayModeEnum,
        },
        {
          title: '付款单状态',
          prop: 'status',
          dictionaryPath: dictTypes.FinPaymentStatusEnum,
        },
      ],
      checkResultInfo: {}, // 校验结果
      isPaymentTipShow: false, // 付款提示弹窗
      isCheckResult: null, // 校验结果
    };
  },
  computed: {
    batchPaymentStr() {
      return this.queryForm.type === '1' ? '批量退款' : '批量付款';
    },
    selectWayOptions() {
      const { dictData = {} } = this.$store.state.dictionary;
      const arr = _.cloneDeep(dictData[dictTypes.FinPayModeEnum] || []);
      arr.unshift({
        value: 'all',
        codeName: '全部',
      });
      return arr;
    },
    exportServe() {
      return this.exportType === 1 ? 'fin_payment_paymentSplitReport' : 'fin_payment_paymentReport';
    },
    searchParams() {
      const params = {
        ...this.queryForm,
      };
      delete params.selectList;
      return params;
    },
    exportParams() {
      const params = {
        ...this.searchParams,
      };
      delete params.page;
      delete params.limit;
      return params;
    },
  },
  created() {
    this.resetDate();
    this.init();
  },
  methods: {
    async init() {
      this.$store.dispatch('dictionary/getDictionary', { type: 'SERVICE_PAYMENT_FS' });
      const { status } = this.$route.query;
      this.queryForm.status = status || '';
      try {
        const list = await this.$store.dispatch('dictionary/getUserTemplate', {
          pageKeys: [this.columnsKey],
          columnsKey: this.columnsKey,
          tableColumn: this.tableColumn,
          recommendedColumn: this.recommendedColumn,
        });
        this.selectTableColumn = list;
      } catch (error) {
        this.selectTableColumn = this.tableColumn;
      }
      this.getList();
    },
    cascaderChange(params) {
      const { selectList, parentSelect, childrenSelect } = params;
      this.queryForm.selectList = selectList;
      this.queryForm.payWays = childrenSelect;
      this.queryForm.payMode = parentSelect;
      this.refreshList();
    },
    // 配置确认
    handleConfirm(values) {
      this.selectTableColumn = values;
      this.$nextTick(() => {
        this.$refs.paymentListRef.doLayout();
      });
    },
    // 复制摘要
    handleCopyDigest() {
      const arr = (this.multipleSelection.map((item) => {
        const { orderNumber, payAmount, businessName, payReason } = item;
        return `${orderNumber}\t${payReason || ''}\t\t${regFenToYuan(payAmount)}\t\t\t${businessName}`;
      }) || []).join('\n');
      this.$copyMessage(arr, '复制摘要成功');
    },
    handleChangeType(item) {
      this.queryForm.type = item.value;
      this.getList();
    },
    // 多选选择返回结果
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 批量确认多选限制设置
    setDisabled(row) {
      if ([1, '1'].includes(row.status)) {
        return 1;
      }
      return 0;
    },
    // 选中的数据
    getMultipleSelection() {
      const businessNos = [];
      const payModes = [];
      const paymentNos = [];
      const busiTypes = [];
      const bankCardNumbers = [];
      const bankAccountTypes = []; // 账户类型，公帐、私帐
      const payeeBusinessNames = []; // 服务商
      const payRemarksList = [];

      let paymentTotalAmount = 0;
      (this.multipleSelection || []).forEach((item) => {
        businessNos.push(item.businessNo);
        payModes.push(item.payMode);
        paymentNos.push(item.paymentNo);
        bankCardNumbers.push(item.bankCardNumber);
        bankAccountTypes.push(item.bankAccountType);
        payeeBusinessNames.push(item.payeeBusinessName);
        busiTypes.push(item.busiType);
        payRemarksList.push(item.payRemarks ?? '');
        paymentTotalAmount += Number(item.payAmount);
      });

      // 不完全相同客户、相同收款账户
      const isBankPay = payModes.every((it) => it === 'BANK_CARD_PAY'); // 银行卡
      const isAliPay = payModes.every((it) => it === 'ALIPAY'); // 支付宝
      const isAllJianban = busiTypes.every((it) => it === 11); // 免费剪板付款单
      this.paymentNo = paymentNos.join(',');
      const isCompany = bankAccountTypes.includes(2); // 是否为对公账户
      const isIncludeJianban = busiTypes.includes(11); // 是否包含了免费剪板付款单

      return {
        isBankPay,
        isAliPay,
        isCompany,
        paymentTotalAmount,
        bankCardNumbers,
        payModes,
        businessNos,
        payeeBusinessNames,
        isAllJianban,
        isIncludeJianban,
        payRemarksList,
      };
    },
    // 付款提交前校验
    checkPayment() {
      let flag = false;
      // 判断有没有已付款的数据
      const flagList = (this.multipleSelection || []).filter((item) => ![1, '1'].includes(item.status));
      // 支付宝-码牌数据
      const alipayFlagList = (this.multipleSelection || []).filter((item) => item.payMode === 'ALIPAY' && item.payWay === 32);
      if (flagList && flagList.length > 0) {
        this.$message.warning('选中的数据中有已付款的付款单！请重新选择');
        flag = true;
      }
      if (alipayFlagList && alipayFlagList.length > 0) {
        this.$message.warning('选中的数据中付款渠道有码牌的付款单！请重新选择');
        flag = true;
      }
      // 单次最大20笔付款单
      if (this.multipleSelection.length > 20) {
        this.$message.warning('单次最多20笔付款单批量付款！请重新选择');
        flag = true;
      }
      return flag;
    },
    async _payCommitCheck() {
      try {
        const paymentNoList = this.paymentNo.split(',');
        const res = await payCommitCheck({ paymentNoList });
        const { data } = res || {};
        this.checkResultInfo = data || {};
        this.isCheckResult = data.checkResult;
      } catch (error) {
        console.log(error);
        this.isCheckResult = null;
      }
    },
    // 合并付款
    async handleMergePayment() {
      if (this.checkPayment()) return;
      const { businessNos, payModes, bankCardNumbers, paymentTotalAmount, isCompany, payeeBusinessNames, payRemarksList } = this.getMultipleSelection();
      if (this.isAllEqual(businessNos) && this.isAllEqual(payModes) && this.isAllEqual(bankCardNumbers) && this.isAllEqual(payeeBusinessNames)) {
        await this._payCommitCheck();
        if (this.isCheckResult) {
        // 同一目标客户、付款方式、收款账户
          const { bankAccountTypeDesc, bankName, bankBranchInfo,
            bankAccountName, bankCardNumber, payWay, payMode, payeeBusinessNo } = this.multipleSelection[0];

          this.paymentObj = {
            bankAccountTypeDesc, // 账户类型
            bankName, // 收款银行
            bankBranchInfo, // 支行名称
            bankAccountName, // 账户名称
            bankCardNumber, // 银行账号
            payWay, // 付款的类型
            paymentTotalNumber: this.multipleSelection.length || 0, // 付款总笔数
            paymentTotal: this.multipleSelection.length || 0, // 付款对象总个数
            paymentTotalAmount, // 付款总额度
            payMode,
            payeeBusinessNo, // 默认服务商
          };
          let paymentType = 'all'; // 默认线上线下
          if (isCompany) {
            paymentType = 'onlyOffline';
          } else {
            const onlineCount = payRemarksList.filter((item) => item === 'online').length;
            const offlineCount = payRemarksList.filter((item) => item === 'offline').length;
            if (onlineCount > offlineCount) {
              paymentType = 'online';
            } else if (offlineCount > onlineCount) {
              paymentType = 'offline';
            } else {
              paymentType = 'all';
            }
          }
          // 付款方式：1-机构代付、 2-微信企业付款、 3-支付宝企业付款、 4-银企直连、 5-人工转账
          this.paymentType = paymentType;
          this.isBatchPay = true;
          this.isPaymentOperateShow = true;
          this.paymentTitle = this.queryForm.type === '1' ? '合并退款' : '合并付款';
        }
        if (!this.isCheckResult && this.isCheckResult !== null) {
          this.isPaymentTipShow = true;
        }
      } else {
        this.$message.warning('请选择同一目标客户、付款方式、收款账户、服务商');
      }
    },
    // 批量确认操作
    async handleBatchPayment() {
      if (this.checkPayment()) return;
      const { isBankPay, paymentTotalAmount, isAliPay, payeeBusinessNames, isAllJianban, isIncludeJianban, payRemarksList } = this.getMultipleSelection();
      const { payeeBusinessNo } = this.multipleSelection[0];
      if (this.isAllEqual(payeeBusinessNames) && (isBankPay || isAliPay) && payRemarksList.every((item) => item === 'online' || item === '')) {
        if (!isAllJianban && isIncludeJianban) {
          this.$message.warning('费剪板付款单不支持与其它单混合支付');
          return;
        }
        await this._payCommitCheck();
        if (this.isCheckResult) {
        // 不完全相同客户、账户
          this.isBatchPaymentShow = true;
          this.paymentObj = {
            paymentTotalAmount,
            paymentTotalNumber: this.multipleSelection.length, // 付款总笔数
            paymentTotal: this.multipleSelection.length, // 付款对象总个数
            payeeBusinessNo,
          };
          this.paymentTitle = this.queryForm.type === '1' ? '批量退款' : '批量付款';
        }
        if (!this.isCheckResult && this.isCheckResult !== null) {
          this.isPaymentTipShow = true;
        }
      } else {
        this.$message.warning('当前勾选的订单暂不支持批量支付，请重新选择');
      }
    },
    // 判断数组值是否都相同
    isAllEqual(array) {
      return array.every((el) => el === array[0]);
    },

    // 付款单操作返回结果
    handleOperateStateResults() {
      this.getList();
    },
    // 详情
    handleDetail(row) {
      this.paymentNo = row?.paymentNo || '';
      this.sourceType = row.sourceType;
      this.isDetailShow = true;
    },

    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    // 列表查询
    async getList() {
      const { searchContent, type, status, payWays, payMode } = this.searchParams;
      if (!this.queryForm.beginTime && !(searchContent || type || status || payMode || payWays.length)) {
        this.resetDate();
      }
      try {
        this.loading = true;
        const res = await getPaymentPaymentList(this.searchParams);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
      } catch (error) {
        console.log(error);
        this.list = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    resetDate() {
      const { startDate, endDate } = getMonthDate();
      this.queryForm.beginTime = startDate || '';
      this.queryForm.endTime = endDate || '';
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.resetDate();
      this.$nextTick(() => {
        this.getList();
      });
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
    // 批量查询提交
    handleBatchSearchConfirm(form) {
      const param = { ...queryFormDefault };
      param.searchType = form.searchType || '';
      param.searchContent = (form.list || []).join(',');
      this.queryForm = { ...param };
      this.isBatchSearchShow = false;
      this.getList();
    },
    // 批量查询弹窗
    handleBatchSearch() {
      this.isBatchSearchShow = true;
    },
    // 关闭导出弹窗
    onCloseExport() {
      this.exportType = 1;
    },
  },
};
</script>

<style scoped lang="scss">
.data-show {
  color: #000;
}
</style>
